export default __webpack_public_path__ + "static/media/134.e022d693.png";